import { Form, Input, InputNumber, Radio, Select, Space } from 'antd'
import { ROOM_TYPE_OPTIONS } from '@/features/master-data/const/room-editor-modal.ts'

export function RoomGenerationFields() {
  const mode = Form.useWatch<'range' | 'list' | undefined>('mode') ?? 'range'
  return (
    <>
      <Form.Item label="生成方式" name="mode" rules={[{ required: true }]}>
        <Radio.Group
          optionType="button"
          options={[
            { label: '编号区间', value: 'range' },
            { label: '粘贴列表', value: 'list' }
          ]}
        />
      </Form.Item>
      {mode === 'range' ? (
        <Form.Item key="range" label="编号区间">
          <Space.Compact block>
            <Form.Item name="prefix" noStyle>
              <Input aria-label="房间编号前缀" placeholder="前缀" className="w-1/4!" />
            </Form.Item>
            <Form.Item name="startNumber" noStyle rules={[{ message: '请输入起始编号', required: true }]}>
              <InputNumber aria-label="起始编号" min={1} precision={0} placeholder="起始" className="w-1/4!" />
            </Form.Item>
            <Form.Item name="endNumber" noStyle rules={[{ message: '请输入结束编号', required: true }]}>
              <InputNumber aria-label="结束编号" min={1} precision={0} placeholder="结束" className="w-1/4!" />
            </Form.Item>
            <Form.Item name="suffix" noStyle>
              <Input aria-label="房间编号后缀" placeholder="后缀" className="w-1/4!" />
            </Form.Item>
          </Space.Compact>
          <div className="mt-2">
            <Form.Item label="编号补零位数（如 2 → 01）" name="padStart" className={'mb-0!'}>
              <InputNumber min={1} max={10} precision={0} placeholder="1" className="w-48" />
            </Form.Item>
          </div>
        </Form.Item>
      ) : (
        <Form.Item
          key="list"
          extra="每行一个房间号，可加面积：A-101 30 或 A-101,30"
          label="房间号列表"
          name="listText"
          rules={[{ message: '请输入房间号列表', required: true }]}
        >
          <Input.TextArea placeholder={'A-101\nA-102\nA-103'} rows={6} />
        </Form.Item>
      )}
      <Form.Item label="楼层" name="floor">
        <Input maxLength={50} placeholder="统一楼层（选填）" />
      </Form.Item>
      <Form.Item label="房间类型" name="roomType" rules={[{ required: true }]}>
        <Select options={ROOM_TYPE_OPTIONS} placeholder="请选择房间类型" />
      </Form.Item>
      <Form.Item extra="区间生成时所有房间共用该面积" label="面积（㎡）" name="area">
        <InputNumber className="w-full" min={0} max={999999.99} placeholder="选填" precision={2} />
      </Form.Item>
    </>
  )
}
